export const defaultUnpatchedConsole = Object.assign({}, console);
//# sourceMappingURL=const.js.map